import { render } from "./admin-modal.vue?vue&type=template&id=77d19d2f&scoped=true"
import script from "./admin-modal.vue?vue&type=script&lang=js"
export * from "./admin-modal.vue?vue&type=script&lang=js"

import "./admin-modal.vue?vue&type=style&index=0&id=77d19d2f&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d19d2f"],['__file',"src/components/admin-dashboard/modals/admin-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77d19d2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77d19d2f', __exports__)) {
    api.reload('77d19d2f', __exports__)
  }
  
  module.hot.accept("./admin-modal.vue?vue&type=template&id=77d19d2f&scoped=true", () => {
    api.rerender('77d19d2f', render)
  })

}


export default __exports__